import { render, staticRenderFns } from "./CreateNewRuleModal.vue?vue&type=template&id=f37e4928&scoped=true"
import script from "./CreateNewRuleModal.vue?vue&type=script&lang=js"
export * from "./CreateNewRuleModal.vue?vue&type=script&lang=js"
import style0 from "./CreateNewRuleModal.vue?vue&type=style&index=0&id=f37e4928&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37e4928",
  null
  
)

export default component.exports